/**
 * 汎用タブ切り替え処理
 *
 * ※タブ切り替えはaria属性を使用して行います。適切なaria属性を設定してください。
 */
export default class TabContents extends HTMLElement {
  constructor() {
    super();

    const self = this;

    // タブ情報
    const tabs = this.querySelectorAll('[role="tab"]');
    const tabPanels = this.querySelectorAll('[role="tabpanel"]');
    const links = this.querySelectorAll('[role="links"]');

    // 初期化処理
    tabs.forEach(function (tab) {
      tab.addEventListener('click', (e) => {
        const isSelected = e.target.getAttribute('aria-selected');
        const id = e.target.getAttribute('aria-controls');
        const tabPanel = self.querySelector(`#${id}`);
        const link = self.querySelector(`[data-target="${id}"]`);

        if (isSelected === 'true') {
          return false;
        }

        tabPanels.forEach(function (panel) {
          panel.setAttribute('aria-hidden', 'true');
        });
        tabPanel.setAttribute('aria-hidden', 'false');

        tabs.forEach(function (tab) {
          tab.setAttribute('aria-selected', 'false');
        });
        e.target.setAttribute('aria-selected', 'true');

        if (link){
          links.forEach(function (link) {
            link.classList.add('hidden');
          });
          link.classList.remove('hidden');
        }
      });
    });
  }
}
